export default __webpack_public_path__ + "img/tremors/tremors4_480.webp";